import React from "react";
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip } from "recharts";
import { ChartTooltip } from "./chartTheme";

const tick = { fontSize: 11, fill: "hsl(150, 10%, 46%)", fontFamily: "Segoe UI Regular, sans-serif, system-ui" };

const ActivationRateChart = ({ data = [] }) => (
  <ResponsiveContainer width="100%" height="100%">
    <LineChart data={data} margin={{ top: 8, right: 12, bottom: 0, left: -12 }}>
      <CartesianGrid strokeDasharray="3 3" stroke="hsl(140, 8%, 90%)" vertical={false} />
      <XAxis dataKey="label" tick={tick} axisLine={{ stroke: "hsl(140, 8%, 88%)" }} tickLine={false} minTickGap={16} />
      <YAxis tick={tick} axisLine={false} tickLine={false} width={32} />
      <Tooltip content={<ChartTooltip />} />
      <Line
        type="monotone"
        dataKey="activation_rate"
        name="Apps / candidate"
        stroke="hsl(168, 58%, 33%)"
        strokeWidth={2.5}
        dot={{ r: 3, fill: "hsl(168, 58%, 33%)", strokeWidth: 0 }}
        activeDot={{ r: 5, stroke: "#fff", strokeWidth: 2, fill: "hsl(168, 58%, 33%)" }}
      />
    </LineChart>
  </ResponsiveContainer>
);

export default ActivationRateChart;
